import has from '@dojo/framework/core/has';
import {
	bonusquizzes,
	clearView,
	keymap,
	locationChange,
	pathmap,
	quizmap,
	userstore,
	viewChange,
	whichActiveView
} from 'lcc-state';
import capitalize from 'lodash-es/capitalize';
import { publish, subscribe } from 'pub-sub';
import { assessment, bonus, posttest, practice, viewFromLpl } from '../../shared/init/lpl';

const log = (name: string) => {
	const { path } = keymap.get(name)!;
	locationChange({ location: path });
};

function setup_locations() {
	keymap.set('', { path: '/', title: '' });
	pathmap.set('/', {
		topic: {},
		view: () => {
			publish('site/homepage');
		}
	});
	['explore', 'explore-assess', 'explore-practice', 'glossary', 'posttest', 'practice'].forEach((loc) => {
		const title = capitalize(loc);
		keymap.set(loc, { path: `/${loc}`, title });
		pathmap.set(`/${loc}`, {
			topic: {},
			view: () => {
				publish(`site/${loc.split('-').join('/')}`);
			}
		});
	});
	keymap.set('explore', { path: '/explore', title: 'Explore The Study Materials' });
}

export function setup_actions(): void {
	subscribe('site/homepage', () => {
		publish('close-all/panes');
		clearView();
		log('explore');
	});

	subscribe('site/assessment', (topic, quiz) => {
		if (quiz) {
			const { title } = keymap.get(quiz)!;
			viewChange({ view: viewFromLpl(assessment(quiz, title)) });
			publish('close-all/panes');
			log(quiz);
		}
	});
	for (const id in quizmap) {
		if (/pre-test/.test(id)) {
			const topic = `site/${id.split('-').join('/')}`;
			subscribe(topic, () => {
				const { quiz } = quizmap.get(id) || {};
				if (quiz) {
					const { title } = keymap.get(id)!;
					viewChange({ view: viewFromLpl(assessment(quiz, title)) });
					publish('close-all/panes');
					log(id);
				}
			});
		}
	}
	subscribe('site/practice', () => {
		const { quiz } = quizmap.get('practice') || {};
		if (quiz) {
			const { title } = keymap.get('practice')!;
			viewChange({ view: viewFromLpl(practice(quiz, title)) });
			publish('close-all/panes');
			log('practice');
		}
	});
	subscribe('site/posttest', () => {
		const { quiz } = quizmap.get('posttest') || {};
		if (quiz) {
			const { title } = keymap.get('posttest')!;
			viewChange({ view: viewFromLpl(posttest(quiz, title)) });
			publish('close-all/panes');
			log('posttest');
		}
	});
	subscribe('site/bonusquiz', (topic, quizid) => {
		const { path, title } = bonusquizzes.get(quizid) || { title: '' };
		if (path) {
			viewChange({ view: viewFromLpl(bonus(quizid, title)) });
			publish('close-all/panes');
			log(quizid);
		}
	});

	subscribe('site/explore', (topic) => {
		const [, , rest] = topic.split('/');
		const location = rest ? `explore-${rest}` : 'explore';
		publish('close-all/panes');
		clearView();
		if (rest && (rest === 'assess' || rest === 'practice')) {
			whichActiveView({ whichActive: rest });
		}
		log(location);
	});

	subscribe('site/glossary', () => {
		publish('close-all/panes');
		log('glossary');
		publish('glossary/open');
	});
	subscribe('site/video', (topic) => {
		const [, , videoid] = topic.split('/');
		publish('close-all/panes');
		publish('video/open', videoid);
	});
	subscribe('site/rcs', (topic) => {
		const [, , ...rest] = topic.split('/');
		const rcspath = `/${rest.join('/')}`;
		publish('close-all/panes');
		publish('rcs/open', rcspath);
	});
	subscribe('site/certificate', () => {
		publish('close-all/panes');
		publish('cert/open');
	});
	subscribe('site/evaluation', () => {
		publish('close-all/panes');
		publish('eval/open');
	});
	subscribe('site/activity', (topic) => {
		const [, , ciaid] = topic.split('/');
		locationChange({ location: `/activity/${ciaid}` });
		viewChange({
			view: {
				widget: 'LearningActivity',
				params: { activityname: ciaid.replaceAll('-', '_') }
			}
		});
	});
	subscribe('site/rise', (topic) => {
		const [, , ciaid] = topic.split('/');
		locationChange({ location: `/rise/${ciaid}` });
		viewChange({
			view: {
				widget: 'RiseActivation',
				params: { activityname: ciaid.replaceAll('-', '_') }
			}
		});
	});

	subscribe('site/landingpage', () => {
		publish('close-all/panes');
		viewChange({
			view: {
				widget: 'LandingPage',
				params: {}
			}
		});
	});

	subscribe('rcs/view', (topic) => {
		const [, , ...rest] = topic.split('/');
		const rcspath = `/${rest.join('/')}`;
		locationChange({ location: rcspath });
		publish('close-all/panes');
		viewChange({
			view: {
				widget: 'ResourceCenter',
				params: { baseurl: rcspath, url: rcspath }
			}
		});
	});

	subscribe('mystudyplan/view', () => {
		const { get: uget, path: upath } = userstore;
		const { complete: landingCompleted = false } = uget(upath('toolstate', 'landing'));
		const skip = !has('use-landing-page');
		publish('close-all/panes');
		clearView();
		if (skip || landingCompleted) {
			publish('active-view', 'study');
		} else {
			publish('site/landingpage');
		}
	});

	subscribe('explore/active', () => {
		publish('close-all/panes');
		clearView();
		viewChange({
			view: {
				widget: 'ActiveView',
				params: {}
			}
		});
	});

	setup_locations();
}
